const ThickChevronUp = ({width = '16', height = '16'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <path
      fill="#E82026"
      d="M13.53 10.53a.752.752 0 0 1-1.062 0L8 6.064 3.53 10.53a.752.752 0 0 1-1.062-1.063l5-5a.75.75 0 0 1 1.063 0l5 5a.75.75 0 0 1 0 1.063Z"
    />
  </svg>
);
export default ThickChevronUp;
